import "@arco-design/web-react/es/Modal/style";
import _Modal from "@arco-design/web-react/es/Modal";
import "@arco-design/web-react/es/Radio/style";
import _Radio from "@arco-design/web-react/es/Radio";
import "@arco-design/web-react/es/Empty/style";
import _Empty from "@arco-design/web-react/es/Empty";
import _IconRefresh from "@arco-design/web-react/icon/react-icon/IconRefresh";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconDelete from "@arco-design/web-react/icon/react-icon/IconDelete";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import "@arco-design/web-react/es/Card/style";
import _Card from "@arco-design/web-react/es/Card";
import "@arco-design/web-react/es/Descriptions/style";
import _Descriptions from "@arco-design/web-react/es/Descriptions";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import _IconFire from "@arco-design/web-react/icon/react-icon/IconFire";
import _IconPhone from "@arco-design/web-react/icon/react-icon/IconPhone";
import _IconCheckCircle from "@arco-design/web-react/icon/react-icon/IconCheckCircle";
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MchWechatBind, MchWechatInfo, MchWechatUnBind, MchRuleInfo, MchRuleUpdate } from '@/utils/service';
import constant from '@/utils/constant';
import styles from './style/index.module.less';
import wechat from '@/assets/wechat.png';

function SettingsModal({
  visible,
  onCancel
}) {
  const [activeKey, setActiveKey] = useState('account');
  const [wechatInfo, setWechatInfo] = useState(null);
  const [qrData, setQrData] = useState(null);
  const [wechatLoading, setWechatLoading] = useState(false);
  const [notificationSettings, setNotificationSettings] = useState({
    notify_trans_out: '',
    notify_trans_in: '',
    notify_in_process_control: ''
  });
  const [notificationLoading, setNotificationLoading] = useState(false);
  const userInfo = useSelector(state => state.userInfo);
  const menuItems = [{
    key: 'account',
    icon: /*#__PURE__*/React.createElement(_IconCheckCircle, null),
    label: '账户信息',
    desc: '查看账户基本信息'
  }, {
    key: 'wechat',
    icon: /*#__PURE__*/React.createElement(_IconPhone, null),
    label: '微信绑定',
    desc: '绑定微信账号接收消息通知'
  }, {
    key: 'notification',
    icon: /*#__PURE__*/React.createElement(_IconFire, null),
    label: '通知设置',
    desc: '管理各类消息通知推送'
  }];
  const notificationOptions = [{
    label: '不通知',
    value: ''
  }, {
    label: '微信通知',
    value: 'wechat'
  }, {
    label: '邮箱通知',
    value: 'email'
  }];

  const handleNotificationChange = (type, value) => {
    setNotificationSettings(prev => ({ ...prev,
      [type]: value
    }));
  };

  const handleSaveNotification = async () => {
    try {
      const res = await MchRuleUpdate(notificationSettings);

      if (res.data && res.data.code === constant.SysSuc) {
        _Message.success('通知设置保存成功');

        await fetchNotificationSettings();
      } else {
        _Message.error('通知设置保存失败');
      }
    } catch (error) {
      console.error('保存通知配置失败', error);

      _Message.error('保存失败，请重试');
    }
  };

  useEffect(() => {
    if (visible && activeKey === 'wechat') {
      initWechatBind();
    } else {
      setWechatInfo(null);
      setQrData(null);
    }
  }, [visible, activeKey]);
  useEffect(() => {
    if (visible && activeKey === 'notification') {
      fetchNotificationSettings();
    }
  }, [visible, activeKey]);

  const fetchNotificationSettings = async () => {
    setNotificationLoading(true);

    try {
      const res = await MchRuleInfo();

      if (res.data && res.data.code === constant.SysSuc) {
        setNotificationSettings({
          notify_trans_out: res.data.data?.notify_trans_out || '',
          notify_trans_in: res.data.data?.notify_trans_in || '',
          notify_in_process_control: res.data.data?.notify_in_process_control || ''
        });
      }
    } catch (error) {
      console.error('获取通知配置失败', error);
    } finally {
      setNotificationLoading(false);
    }
  };

  const initWechatBind = async () => {
    setWechatLoading(true);

    try {
      const res = await MchWechatInfo();

      if (res.data && res.data.code === constant.SysSuc) {
        const data = res.data.data;
        setWechatInfo(data);

        if (!data.bind) {
          fetchQrCode();
        }
      }
    } catch (error) {
      console.error('获取微信绑定信息失败', error);
    } finally {
      setWechatLoading(false);
    }
  };

  const fetchWechatInfo = async () => {
    try {
      const res = await MchWechatInfo();

      if (res.data && res.data.code === constant.SysSuc) {
        const data = res.data.data;
        setWechatInfo(data);

        if (!data.bind && isQrExpired()) {
          fetchQrCode();
        }
      }
    } catch (error) {
      console.error('获取微信绑定信息失败', error);
    }
  };

  const isQrExpired = () => {
    if (!qrData?.expire) return true;
    const expireTime = new Date(qrData.expire).getTime();
    const now = Date.now();
    return now > expireTime;
  };

  const fetchQrCode = async () => {
    try {
      const res = await MchWechatBind();

      if (res.data && res.data.code === constant.SysSuc) {
        setQrData(res.data.data);
      }
    } catch (error) {
      console.error('获取二维码失败', error);
    }
  };

  const handleUnbind = () => {
    MchWechatUnBind().then(res => {
      if (res.data) {
        const {
          code
        } = res.data;

        if (code === constant.SysSuc) {
          _Message.success('微信解绑成功');

          initWechatBind();
        } else {
          _Message.error('微信解绑失败');
        }
      }
    });
  };

  useEffect(() => {
    let interval = null;

    if (visible && activeKey === 'wechat' && qrData && !wechatInfo?.bind) {
      interval = setInterval(fetchWechatInfo, 3000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [visible, activeKey, qrData, wechatInfo?.bind]);
  return /*#__PURE__*/React.createElement(_Modal, {
    visible: visible,
    onCancel: onCancel,
    footer: null,
    style: {
      width: '800px'
    },
    className: styles['settings-modal']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['settings-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['settings-left']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-header']
  }, /*#__PURE__*/React.createElement(_IconCheckCircle, {
    className: styles['header-icon']
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['header-title']
  }, "\u8BBE\u7F6E\u4E2D\u5FC3")), /*#__PURE__*/React.createElement("div", {
    className: styles['menu-list']
  }, menuItems.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.key,
    onClick: () => setActiveKey(item.key),
    className: `${styles['menu-item']} ${activeKey === item.key ? styles['menu-item-active'] : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-item-main']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['menu-icon']
  }, item.icon), /*#__PURE__*/React.createElement("div", {
    className: styles['menu-text']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['menu-label']
  }, item.label), /*#__PURE__*/React.createElement("span", {
    className: styles['menu-desc']
  }, item.desc))), activeKey === item.key && /*#__PURE__*/React.createElement("div", {
    className: styles['menu-indicator']
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles['settings-right']
  }, activeKey === 'account' && /*#__PURE__*/React.createElement("div", {
    className: styles['panel-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['panel-header']
  }, /*#__PURE__*/React.createElement(_IconCheckCircle, {
    className: styles['panel-icon']
  }), /*#__PURE__*/React.createElement("h3", null, "\u8D26\u6237\u4FE1\u606F")), /*#__PURE__*/React.createElement(_Card, {
    className: styles['info-card'],
    bordered: false
  }, /*#__PURE__*/React.createElement(_Descriptions, {
    column: 1,
    data: [{
      label: '用户名:',
      value: userInfo?.realname || '-'
    }, {
      label: '商户名称:',
      value: userInfo?.incomeInfo?.regName || '-'
    }, {
      label: '用户手机:',
      value: userInfo?.phone || '-'
    }, {
      label: '用户邮箱:',
      value: userInfo?.email || '-'
    }]
  }))), activeKey === 'wechat' && /*#__PURE__*/React.createElement("div", {
    className: styles['panel-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['panel-header']
  }, /*#__PURE__*/React.createElement(_IconPhone, {
    className: styles['panel-icon']
  }), /*#__PURE__*/React.createElement("h3", null, "\u5FAE\u4FE1\u7ED1\u5B9A")), /*#__PURE__*/React.createElement(_Card, {
    className: styles['info-card'],
    bordered: false
  }, wechatLoading ? /*#__PURE__*/React.createElement("div", {
    className: styles['qr-loading']
  }, /*#__PURE__*/React.createElement(_Spin, null)) : wechatInfo?.bind ? /*#__PURE__*/React.createElement("div", {
    className: styles['bind-success']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['bind-icon']
  }, /*#__PURE__*/React.createElement("img", {
    src: wechat,
    style: {
      height: 80,
      paddingLeft: 10,
      marginBottom: -5
    }
  })), /*#__PURE__*/React.createElement("h4", {
    className: styles['bind-title']
  }, "\u5FAE\u4FE1\u5DF2\u7ED1\u5B9A"), /*#__PURE__*/React.createElement("p", {
    className: styles['bind-desc']
  }, "\u60A8\u7684\u5FAE\u4FE1\u8D26\u53F7\u5DF2\u6210\u529F\u7ED1\u5B9A\uFF0C\u53EF\u63A5\u6536\u6D88\u606F\u901A\u77E5"), /*#__PURE__*/React.createElement(_Button, {
    icon: /*#__PURE__*/React.createElement(_IconDelete, null),
    onClick: handleUnbind,
    status: "danger",
    size: "small",
    className: styles['unbind-button']
  }, "\u89E3\u9664\u7ED1\u5B9A")) : qrData?.qr_code_url ? /*#__PURE__*/React.createElement("div", {
    className: styles['qr-container']
  }, /*#__PURE__*/React.createElement("h4", {
    className: styles['qr-title']
  }, "\u626B\u7801\u7ED1\u5B9A\u5FAE\u4FE1"), /*#__PURE__*/React.createElement("p", {
    className: styles['qr-desc']
  }, "\u5FAE\u4FE1\u626B\u63CF\u4E0B\u65B9\u4E8C\u7EF4\u7801\xA0", /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'red'
    }
  }, "\u5173\u6CE8\u670D\u52A1\u53F7\u300A\u7535\u5546\u5206\u8D26\u5B9D\u300B"), "\xA0\u5B8C\u6210\u7ED1\u5B9A"), /*#__PURE__*/React.createElement("div", {
    className: styles['qr-image-wrapper']
  }, /*#__PURE__*/React.createElement("img", {
    src: qrData.qr_code_url,
    alt: "\u5FAE\u4FE1\u7ED1\u5B9A\u4E8C\u7EF4\u7801",
    className: styles['qr-image']
  })), /*#__PURE__*/React.createElement("p", {
    className: styles['qr-tip']
  }, "\u4E8C\u7EF4\u7801\u6709\u6548\u671F\u5185\u53EF\u91CD\u590D\u626B\u63CF"), /*#__PURE__*/React.createElement(_Button, {
    icon: /*#__PURE__*/React.createElement(_IconRefresh, null),
    onClick: fetchQrCode,
    type: "outline",
    size: "small"
  }, "\u5237\u65B0\u4E8C\u7EF4\u7801")) : /*#__PURE__*/React.createElement(_Empty, {
    description: /*#__PURE__*/React.createElement("span", {
      className: styles['empty-text']
    }, "\u83B7\u53D6\u4E8C\u7EF4\u7801\u5931\u8D25")
  }))), activeKey === 'notification' && /*#__PURE__*/React.createElement("div", {
    className: styles['panel-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['panel-header']
  }, /*#__PURE__*/React.createElement(_IconFire, {
    className: styles['panel-icon']
  }), /*#__PURE__*/React.createElement("h3", null, "\u901A\u77E5\u8BBE\u7F6E")), /*#__PURE__*/React.createElement(_Card, {
    className: styles['notification-card'],
    bordered: false
  }, notificationLoading ? /*#__PURE__*/React.createElement("div", {
    className: styles['qr-loading']
  }, /*#__PURE__*/React.createElement(_Spin, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['notification-item']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['notification-label']
  }, "\u63D0\u73B0\u6210\u529F\u901A\u77E5"), /*#__PURE__*/React.createElement(_Radio.Group, {
    type: "button",
    value: notificationSettings.notify_trans_out,
    onChange: value => handleNotificationChange('notify_trans_out', value)
  }, notificationOptions.map(option => /*#__PURE__*/React.createElement(_Radio, {
    key: option.value,
    value: option.value
  }, option.label)))), /*#__PURE__*/React.createElement("div", {
    className: styles['notification-item']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['notification-label']
  }, "\u5165\u91D1\u901A\u77E5"), /*#__PURE__*/React.createElement(_Radio.Group, {
    type: "button",
    value: notificationSettings.notify_trans_in,
    onChange: value => handleNotificationChange('notify_trans_in', value)
  }, notificationOptions.map(option => /*#__PURE__*/React.createElement(_Radio, {
    key: option.value,
    value: option.value
  }, option.label)))), /*#__PURE__*/React.createElement("div", {
    className: styles['notification-item']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['notification-label']
  }, "\u4E8B\u4E2D\u63D0\u9192\u901A\u77E5"), /*#__PURE__*/React.createElement(_Radio.Group, {
    type: "button",
    value: notificationSettings.notify_in_process_control,
    onChange: value => handleNotificationChange('notify_in_process_control', value)
  }, notificationOptions.map(option => /*#__PURE__*/React.createElement(_Radio, {
    key: option.value,
    value: option.value
  }, option.label)))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '16px',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: handleSaveNotification
  }, "\u4FDD\u5B58\u8BBE\u7F6E"))))));
}

export default SettingsModal;